import React, { useContext } from 'react';
import Link from 'next/link';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { Alert } from '@tmap/mmm-style-guide/src/Alert';
import CommunityContext from '../../lib/community/communityContext';

const PendingAlert = styled(Alert)(({ theme }) => ({
  color: theme.palette.warning.main,
  margin: '0',
  width: '100%',
  '.MuiAlert-message': {
    width: '100%',
  },
}));

function PendingCTA({ numPending }) {
  const community = useContext(CommunityContext);
  return (
    <Grid item xs={12} sx={{ padding: 0 }}>
      <PendingAlert severity='warning' icon={false}>
        <Grid container justifyContent='space-between' sx={{ width: '100%' }}>
          <Grid item xs>
            {numPending} Posts Pending Approval
          </Grid>
          <Grid item sx={{ textDecoration: 'underline' }}>
            <Link href={`/moving-living/${community.slug.current}/review`}>Review</Link>
          </Grid>
        </Grid>
      </PendingAlert>
    </Grid>
  );
}

export default PendingCTA;
